/*** IMPORTS FROM imports-loader ***/
var define = false;

import filter from './filter.js';

// Trim out all falsy values from an array.
export default function compact(array) {
  return filter(array, Boolean);
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/compact.js
// module id = 138
// module chunks = 0